import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addDoc, collection } from "firebase/firestore";
import db from "../firestore";
import Header from "../Components/Header";
import { ToastContainer, toast } from "react-toastify";

function FaqAdd() {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  const FaqRef = collection(db, "Faq");
  let navigate = useNavigate();

  const createFaq = async () => {
    await addDoc(FaqRef, { Q: question, A: answer})
    .then(
      toast.success("Added 👍", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    )
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col items-center">
      <Header />
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>

      <div className="w-3/4 border rounded mt-10 p-5 flex flex-col gap-5">
        <h2 className="text-2xl font-bold">Adding Faq</h2>
        <input
          type="text"
          placeholder="FAQ Question*"
          onChange={(e) => {
            setQuestion(e.target.value);
          }}
          className="border rounded p-2"
        />
        <input
          type="title"
          placeholder="FAQ Answer*"
          onChange={(e) => {
            setAnswer(e.target.value);
          }}
          className="border rounded p-2"
        />

        <button
          className="rounded bg-add-green px-5 py-2 text-white hover:bg-add-green2 w-1/4"
          onClick={createFaq}
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default FaqAdd;
